<template>
  <Layout>
    <b-overlay :show="isLoading" rounded="sm">
    <div class="card">
      <div class="card-body">
        <PageHeader :title="title" :items="items" />
         <div class="container">
           <div class="form-row">
             <div class="form-group col-md-4">
               <label>Fecha</label>

               <VueCtkDateTimePicker
                       v-model="fecha"
                       :locale="'es'"
                       :input-size="'sm'"
                       :format="'YYYY-MM-DD'"
                       :formatted="'YYYY-MM-DD'"
                       :range="false"
                       :auto-close="true"
                       :only-date="true"
                       :no-header="true"
               />
               <!--:no-header="true"-->

             </div>
             <div class="form-group col-md-3">
               <button class="btn btn-primary mt-4 mr-1" v-on:click="loadItems">Ver</button>
               <button class="btn btn-primary mt-4" v-on:click="reportePDF">Reporte PDF</button>
             </div>

             <div class="form-group col-md-4 mt-4">
               <h3>
                 <!--Fecha : {{fecha_mostrar}}-->
               </h3>

             </div>
           </div>
           <div class="row" >
             <table class="table table-bordered">
               <thead>
               <tr>
                 <th>ID</th>
                 <th>Carrera</th>
                 <th>Tipo</th>
                 <th>Nombre</th>
                 <th>Entrada</th>
                 <th>Salida</th>
                 <th>Observacion</th>
               </tr>
               </thead>
               <tbody>
               <tr v-for="(data, index) in lista" v-bind:key="index">
                 <td>{{data.id}}</td>
                 <td>{{data.carrera}}</td>
                 <td>{{data.tipo}}</td>
                 <td>{{data.nombres}}</td>
                 <td>{{data.entrada}}</td>
                 <td>{{data.salida}}</td>
                 <td>{{data.observaciones}}</td>
               </tr>

               </tbody>
             </table>

           </div>

          </div>


        </div>



      </div>
    </b-overlay>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";

/**
 * Dashboard Component
 */
export default {
  page: {
    title: "Reportes",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {
    Layout,
    PageHeader,

  },
  data() {
    return {
      title: "Reportes",
      items: [
        {
          text: "Asistencia",

        }

      ],
      isLoading: false,
      server: process.env.VUE_APP_BACKEND,
      lista:[],
      fecha:null,
      fecha_mostrar:null
    };
  },

  methods: {
    reportePDF(){
      this.isLoading = true;
      this.axios.get(process.env.VUE_APP_BACKEND+"/api/reporte-asistencia/pdf?fecha="+this.fecha , {
        responseType: "blob"
      })
      .then(response => {
        console.log("Success", response);
        const blob = new Blob([response.data],{ type: 'application/pdf' });
        //const objectUrl = URL.createObjectURL(blob);
        var fileURL = URL.createObjectURL(blob);
        window.open(fileURL);
        /*
        const link = document.createElement('a');
        // create a blobURI pointing to our Blob
        link.href = URL.createObjectURL(blob);
        link.download = "reporte.pdf";
        // some browser needs the anchor to be in the doc
        document.body.append(link);
        link.click();
        link.remove();*/
        //URL.revokeObjectURL(link.href)
      })
      .finally(()=>{
        this.isLoading = false;
      });


    },

    loadItems()
    {
      this.isLoading = true;
      this.axios.get(
      process.env.VUE_APP_BACKEND + "/api/reporte-asistencia-completa",
          {
            params:
                    {
                      fecha:this.fecha,
                    }
          }
      )
      .then((response)=> {
        this.fecha_mostrar=this.fecha;
        this.lista=response.data;
      })
      .catch(() => {
        this.$swal("error", "Error", "error");
      })
      .finally(() => {
        this.isLoading = false;
      });
    },
    marcarAsistencia(){

    },
  },
  mounted() {
    var date= new Date();
    this.fecha=new Date(date.getTime() - (date.getTimezoneOffset() * 60000)).toISOString().substring(0, 10)

  }

}
</script>

<style>
.fixtable {
  color: #000000 !important;
}
</style>
